import { instance } from "config/axiosInstance";

const baseURL = process.env.REACT_APP_TENANT_BE;

export async function getSalesRecap(pathname = "", queryParams = "") {
  return await instance({ baseURL }).get(pathname + queryParams);
}

export async function createSalesRecap(pathname, body) {
  return await instance({ baseURL }).post("/sales-recap" + pathname, body);
}

export async function updateSalesRecap(pathname, body) {
  return await instance({ baseURL }).patch("/sales-recap" + pathname, body);
}

export async function deleteSalesRecap(pathname) {
  return await instance({ baseURL }).delete("/sales-recap" + pathname);
}

export async function calculateRevenueShare(body) {
  return await instance({ baseURL }).post("/sales-recap/calculate", body);
}

export async function createInvoiceFromRecap(body) {
  return await instance({ baseURL }).post("/sales-recap/create-invoice", body);
}
